import React, { Component } from "react";
import { Container } from "semantic-ui-react";

import PageHeader from "../../../components/liminal/PageHeader";
import PageFooter from "../../../components/liminal/PageFooter";
import raw from "raw.macro";
import ReactMarkdown from "react-markdown";

const HELP = {
  en: {
    start: raw(`./src/help/en_start.md`),
    about: raw(`./src/help/en_about.md`)
  }
};

class HelpPage extends Component {
  constructor(props) {
    super(props);
    this.state = { searchTerm: "" };
  }
  render() {
    return (
      <div className="help-page-wrapper">
        <PageHeader search={this.props.search} history={this.props.history} />
        <Container text>
          <ReactMarkdown source={HELP["en"][this.props.page]} />
        </Container>
        <PageFooter />
      </div>
    );
  }
}
export { HelpPage };
